import { render, staticRenderFns } from "./SkillsForLesson.vue?vue&type=template&id=5d8a6566"
import script from "./SkillsForLesson.vue?vue&type=script&lang=js"
export * from "./SkillsForLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports